import isError from "lodash/isError";
import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { Logger } from "~/tools/logger";
import { EMPTY, catchError, flatMap, from, map, of } from "~/tools/rxjs";

import { provision, retryProvision } from "../../../../backend/StackPacksApi";
import { ofType } from "../../../../generic/redux/TypedRedux";
import {
	type ProvisionStackPack,
	type ProvisionStackPackError,
	type ProvisionStackPackSuccess,
	provisionStackPackError,
	provisionStackPackSuccess,
} from "../../pages/stackPacks/details/StackPacksDetailsActions";
import { STACK_PACKS_PROVISION_START } from "../../pages/stackPacks/details/StackPacksDetailsActionTypes";
import type { EpicDependencies } from "../../ReduxStore";
import type { RootState } from "../../RootState";

type Response = ProvisionStackPackSuccess | ProvisionStackPackError;

const logger = Logger.namespace("StackPacksProvisionEpic");

export const StackPacksProvisionEpic: Epic<AnyAction, Response, RootState, EpicDependencies> = (actions) =>
	actions.pipe(
		ofType(STACK_PACKS_PROVISION_START),
		flatMap(({ stackPack, fields, configurationId, flag }: ProvisionStackPack) =>
			from(
				configurationId ? retryProvision(stackPack.name, configurationId, flag!) : provision(stackPack, fields),
			).pipe(
				map((config) => provisionStackPackSuccess(config, stackPack)),
				catchError((error: unknown) => {
					if (!isError(error)) {
						return EMPTY;
					}

					logger.error(error);
					return of(provisionStackPackError(error, stackPack));
				}),
			),
		),
	);
